import "./Calculator.css";
import { useState, useEffect } from 'react';
import MaskedInput from "react-text-mask";
import { CommaSeprator, convertIntoLakh } from "../UtilityComponents/UtilityFunction";
import RetirementGraph from "./Graphs-Component/RetirementGraph";
import BarGraphCostOfDelay from "./BarGraphCostOfDelay";
function RetirementCalcDemo(props) {

    const [monthlyExpense, setMonthlyExpense] = useState(50000);
    const [currentAge, setCurrentAge] = useState(35);
    const [retirementAge, setRetirementAge] = useState(60);
    const [extistingInvestment, setExtistingInvestment] = useState(100000);
    const [expectedReturn, setExpectedReturn] = useState(8);
    const [inflationRate, setInflationRate] = useState(6);
    const [corpusRequired, setCorpusRequired] = useState(null);
    const [monthlyContribution, setMonthlyContribution] = useState(null);
    const [inflatedMonthly, setInflatedMonthly] = useState(null);
    const [error, setError] = useState({});

    //props data
    const [yrsData, setYrsData] = useState(null);
    const [amtData, setAmtData] = useState(null);
    const [investHeight, setInvestHeight] = useState(0);
    const [corpusHeight, setCorpusHeight] = useState(0);
    const [yrsGap, setYrsGap] = useState(null);
    const [amtGap, setAmtGap] = useState(null);

    useEffect(() => {
        let goto = true;
        let error = {};

        if (currentAge < 18) {
            goto = false;
            error["currAge"] = "Age must be atleast 18 years";
        }
        if (retirementAge - currentAge < 5) {
            goto = false;
            error["retireAge"] =
                "There should be a minimum gap of 5 years between current Age and Retirement Age";
        }
        if (retirementAge > 65) {
            goto = false;
            error["retireAge"] = 
            "Retirement age should not be more than 65 years"
        }
        if (monthlyExpense < 10000 || monthlyExpense > 10000000) {
            goto = false;
            error["exp"] = "Monthly expense  should be between 10 thousand to 1 crore";
        }
        if (extistingInvestment > 100000000) {
            goto = false;
            error["expFund"] = "Existing investment should not be more than 10 crore";
        }
        setError(error);

        if (goto) {
            const timeToRetirement = retirementAge - currentAge;
            const annualExpense = monthlyExpense * 12;

            const expectedAnnualExpense =
                annualExpense * Math.pow(1 + inflationRate / 100, timeToRetirement);
            // //console.log("expectedAnnualExpense", expectedAnnualExpense/12);

            setInflatedMonthly((expectedAnnualExpense / 12).toFixed(0));

            const totalCorpusRequired =
                expectedAnnualExpense * (70 - retirementAge) - extistingInvestment;
            // //console.log("totalCorpusRequired", totalCorpusRequired);
            setCorpusRequired(totalCorpusRequired.toFixed(0));

            const monthlyAmt =
                (Math.pow(1 + expectedReturn / (100 * 12), timeToRetirement * 12) - 1) /
                (expectedReturn / (100 * 12));
            // //console.log(monthlyAmt);
            const monthlyContribution = totalCorpusRequired / monthlyAmt;
            // //console.log(monthlyContribution);

            setMonthlyContribution(monthlyContribution.toFixed(0));

            let xaxis = [];
            let scaleX = [];
            let diffToShowX = Math.round(timeToRetirement / 5);
            // //console.log(diffToShowX, "divide in xaxis");

            for (let i = diffToShowX; i <= timeToRetirement; i = i + diffToShowX) {
                xaxis.push(i);
            }

            if (!xaxis.includes(timeToRetirement)) {
                xaxis.push(timeToRetirement);
            }
            // //console.log(xaxis);
            if (xaxis.length > 5) {
                for (let i = 0; i < (xaxis.length - 5); i++) {
                    xaxis.shift();
                }
            }
            setYrsData(xaxis);

            // //console.log("scale", xaxis[0] / xaxis[xaxis.length - 1]);
            let xIdx1 = Math.round((xaxis[0] / xaxis[xaxis.length - 1]) * 100);
            scaleX.push(xIdx1);
            scaleX.push(100);
            // //console.log(scaleX);
            setYrsGap(scaleX);

            let yaxis = [];
            let scaleY = [];
            let diffToShowY = (totalCorpusRequired / 5);
            // //console.log(diffToShowY, "divide in y axis");

            for (let i = diffToShowY; i <= totalCorpusRequired; i = i + diffToShowY) {
                yaxis.push(i);
            }

            if (!yaxis.includes(totalCorpusRequired)) {
                yaxis.push(Math.round(totalCorpusRequired));
            }

            // //console.log(yaxis);
            setAmtData(yaxis);

            let yIdx1 = Math.round((yaxis[0] / yaxis[yaxis.length - 1]) * 100);
            scaleY.push(yIdx1);
            scaleY.push(100);
            // //console.log(scaleY);
            setAmtGap(scaleY);

            let totalInvestmentAmt = annualExpense * timeToRetirement;
            let investAmtPercent = Math.round(
                (totalInvestmentAmt / totalCorpusRequired) * 100
            );
            setInvestHeight(investAmtPercent);

            let corpusAmtPercent = (totalCorpusRequired / totalCorpusRequired) * 100;
            setCorpusHeight(corpusAmtPercent);

            // //console.log(investAmtPercent, corpusAmtPercent);
        }
    }, [
        retirementAge,
        currentAge,
        extistingInvestment,
        monthlyExpense,
        expectedReturn,
        inflationRate,
    ]);

   

    return (
        <>
            <div className="Calculator InvestmentLoginPage">
                <div className="CalculatorHead RetirementCalc">
                    <h2>Calculate Retirement Planning</h2>
                    <button className="clsBtn" onClick={props.close}>
                        <img src={require("../../Investment/Cross.svg").default} alt="" />
                    </button>
                </div>
                <div id="invstmntcalc" className="row">
                    <div className="col-md-6">
                        <form className="RetireCalcForm">
                            <div className="CalcForm UserAge">
                                <label className="InLabel" htmlFor="investmentAmount">Your age</label>
                                <MaskedInput
                                    mask={[
                                        /[0-9]/,
                                        /\d/,
                                    ]}
                                    guide={false}
                                    showMask={false}
                                    className="packageForm"
                                    value={currentAge}
                                    onChange={(e) => setCurrentAge(e.target.value)}
                                />
                                <span className="yearsSet">{currentAge ? "years" : ""}</span>
                                <small class="Error-Text">{error.currAge}</small>
                            </div>

                            <div className="CalcForm UserRetirementPlan">
                                <label className="InLabel" htmlFor="investmentAmount">You are planning to retire at</label>
                                <MaskedInput
                                    mask={[
                                        /[0-9]/,
                                        /\d/,
                                    ]}
                                    guide={false}
                                    showMask={false}
                                    className="packageForm"
                                    value={retirementAge}
                                    onChange={(e) => setRetirementAge(e.target.value)}
                                />
                                <span className="yearsSet">{retirementAge ? "years" : ""}</span>
                                <small class="Error-Text">{error.retireAge}</small>
                            </div>

                            <div className="CalcForm">
                                <label className="InLabel" htmlFor="investmentAmount">Your current monthly expenses</label>
                                <MaskedInput
                                    mask={[
                                        /[0-9]/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                    ]}
                                    guide={false}
                                    showMask={false}
                                    className="packageForm"
                                    value={"₹ " + CommaSeprator(monthlyExpense)}
                                    onChange={(e) => setMonthlyExpense(e.target.value)}
                                />
                                <span className="InvAmntSet">{"₹" +convertIntoLakh(monthlyExpense)}</span>
                                <small class="Error-Text">{error.exp}</small>
                            </div>

                            <div className="CalcForm">
                                <label className="InLabel" htmlFor="investmentAmount">Existing investment for retirement</label>
                                <MaskedInput
                                    mask={[
                                        /[0-9]/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                    ]}
                                    guide={false}
                                    showMask={false}
                                    className="packageForm"
                                    value={"₹ " + CommaSeprator(extistingInvestment)}
                                    onChange={(e) => setExtistingInvestment(e.target.value)}
                                />
                                <p className="NoteText">(Including EPF contributions)</p>
                                <span className="InvAmntSet">{"₹"+convertIntoLakh(extistingInvestment)}</span>
                                <small class="Error-Text">{error.expFund}</small>
                            </div>

                            <div className="CalcForm ExpIR">
                                <label className="InLabel" htmlFor="interestRate">Expected inflation rate</label>
                                <MaskedInput
                                    mask={[
                                        /[0-9]/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                    ]}
                                    guide={false}
                                    showMask={false}
                                    className="packageForm"
                                    value={inflationRate}
                                    onChange={(e) => setInflationRate(e.target.value)}
                                />
                                <span className="RateSet">{inflationRate ? "%" : ""}</span>

                                <input
                                    type="range"
                                    className="slider border-0"
                                    min={1}
                                    max={20}
                                    step={1}
                                    value={inflationRate}
                                    onChange={(e) => setInflationRate(e.target.value)}
                                />
                                <ul className="InterestRate">
                                    <li>1%</li>
                                    <li>5%</li>
                                    <li>10%</li>
                                    <li>15%</li>
                                    <li>20%</li>
                                </ul>
                            </div>

                            <div className="CalcForm ExpRI Extra">
                                <label className="InLabel" htmlFor="interestRate">Expected return on investment</label>
                                <MaskedInput
                                    mask={[
                                        /[0-9]/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                    ]}
                                    guide={false}
                                    showMask={false}
                                    className="packageForm"
                                    value={expectedReturn}
                                    onChange={(e) => setExpectedReturn(e.target.value)}
                                />
                                <span className="RateSet">{expectedReturn ? "%" : ""}</span>

                                <input
                                    type="range"
                                    className="slider border-0"
                                    min={1}
                                    max={30}
                                    step={1}
                                    value={expectedReturn}
                                    onChange={(e) => setExpectedReturn(e.target.value)}
                                />
                                <ul className="InterestRate">
                                    <li>1%</li>
                                    <li>5%</li>
                                    <li>10%</li>
                                    <li>15%</li>
                                    <li>20%</li>
                                    <li>25%</li>
                                    <li>30%</li>
                                </ul>
                            </div>

                        </form>
                    </div>
                    <div className="col-md-6">
                        <div className="CalcAmtInvt costofdelay">
                            <div className='CODbox'>
                                <p>To maintain your current standard of living after retirement, you should consider making a <strong>monthly investment of ₹{CommaSeprator(monthlyContribution)}</strong> in order to accumulate a corpus of <strong>₹{convertIntoLakh(corpusRequired)}</strong> by the time you retire. Which will be required to meet your monthly expense of approx. <strong>₹{CommaSeprator(inflatedMonthly)}</strong> as per the inflation rate of {inflationRate}%.</p>
                            </div>
                        </div>

                        {/*<div className="BarGraph">
                            {yrsData && < RetirementGraph xAxis={yrsData} yAxis={amtData} heightInvested={investHeight} corpusHeight={corpusHeight} xAxisGap={yrsGap} yAxisGap={amtGap} />}
                        </div>*/}
                        <div className="BarGraph">
                            < BarGraphCostOfDelay
                                percent={Math.round((corpusRequired / corpusRequired) * 100)}
                                amt={corpusRequired}
                                Msg="Your total corpus amount"
                                IsDelayGraph={false}
                            />

                            < BarGraphCostOfDelay
                                percent={Math.round((((monthlyContribution * 12) * (retirementAge - currentAge)) / corpusRequired) * 100)}
                                amt={(monthlyContribution * 12) * (retirementAge - currentAge)}
                                Msg="Your total invested amount"
                                IsDelayGraph={true}
                            />

                        </div>
                    </div>
                </div>


                <small className="Disclaimer">
                    <i>
                        Disclaimer: The figures presented here are solely for demonstrative purposes. The outcomes are computed using the provided information and should not be considered as the sole basis for making investment decisions.
                    </i>
                </small>

            </div>
        </>
    );
};

export default RetirementCalcDemo;
